export const MINDMAPPI_BRANCH_MARKER = '<!-- mindmappi-branch:v1 -->';
export const MAX_IMPORTED_BRANCH_IDEAS = 200;

function cleanIdeaText(value) {
  return String(value || '').trim().replace(/\s+/g, ' ');
}

export function parseMindmappiBranchMarkdown(source) {
  const lines = String(source || '').replace(/\r\n?/g, '\n').split('\n');
  const firstContentIndex = lines.findIndex((line) => line.trim());
  if (firstContentIndex < 0 || lines[firstContentIndex].trim() !== MINDMAPPI_BRANCH_MARKER) {
    return null;
  }

  const ideas = [];
  let headingIndex = null;
  const stack = [];
  for (let index = firstContentIndex + 1; index < lines.length; index += 1) {
    const line = lines[index];
    const heading = line.match(/^\s*#\s+(.+)$/);
    if (heading && ideas.length === 0) {
      const text = cleanIdeaText(heading[1]);
      if (text) {
        headingIndex = ideas.length;
        ideas.push({ text, parentIndex: null, isTask: false, taskDone: false });
      }
      continue;
    }

    const bullet = line.match(/^(\s*)[-*+]\s+(?:\[([ xX])\]\s+)?(.+)$/);
    if (!bullet) continue;
    const text = cleanIdeaText(bullet[3]);
    if (!text) continue;
    const indentation = bullet[1].replaceAll('\t', '  ').length;
    const depth = Math.floor(indentation / 2);
    while (stack.length > depth) stack.pop();
    const parentIndex = stack.length
      ? stack[stack.length - 1]
      : headingIndex;
    const ideaIndex = ideas.length;
    ideas.push({
      text,
      parentIndex,
      isTask: bullet[2] !== undefined,
      taskDone: String(bullet[2] || '').toLowerCase() === 'x',
    });
    stack[depth] = ideaIndex;
    stack.length = depth + 1;
    if (ideas.length > MAX_IMPORTED_BRANCH_IDEAS) {
      throw new Error(`Mindmappi branch files can contain at most ${MAX_IMPORTED_BRANCH_IDEAS} ideas.`);
    }
  }

  if (!ideas.length) {
    throw new Error('This Mindmappi branch file does not contain a heading or bulleted ideas.');
  }
  return ideas;
}
